{
  "header": {
    "brandName": "GlobalAnka",
    "ctaPath": "/contact",
    "navLinks": [
      { "to": "/", "labelKey": "nav.home", "end": true },
      { "to": "/about", "labelKey": "nav.about" },
      { "to": "/portfolio", "labelKey": "nav.portfolio" },
      { "to": "/contact", "labelKey": "nav.contact" }
    ]
  },
  "footer": {
    "tagline": "Stratejik vizyon ve küresel yetenek ağı ile kurumsal başarınızı inşa ediyoruz. Yarının çözümlerini bugün tasarlıyoruz.",
    "company": "GlobalAnka Uluslararası Danışmanlık",
    "rights": "Tüm hakları saklıdır.",
    "navTitle": "Navigasyon",
    "contact": "İletişim",
    "contactRows": [
      {
        "title": "Adres",
        "body": "Levent Plaza, Büyükdere Cad. No:173, Şişli, İstanbul",
        "href": ""
      },
      {
        "title": "E-posta",
        "body": "kurumsal@globalanka.com",
        "href": "mailto:kurumsal@globalanka.com"
      },
      {
        "title": "Telefon",
        "body": "+90 (212) 555 01 99",
        "href": "tel:+902125550199"
      }
    ],
    "social": [
      { "href": "https://linkedin.com/company/globalanka", "label": "LinkedIn", "icon": "linkedin", "active": true },
      { "href": "https://instagram.com/globalanka", "label": "Instagram", "icon": "instagram", "active": true },
      { "href": "https://wa.me/902125550199", "label": "WhatsApp", "icon": "whatsapp", "active": true }
    ],
    "mainNavLinks": [
      { "to": "/about", "labelKey": "nav.about" },
      { "to": "/portfolio", "labelKey": "nav.portfolio" },
      { "to": "/contact", "labelKey": "nav.contact" }
    ]
  }
}
